// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.seance.test/' : 'https://api.séance.com/';
export const contentAPI = 'https://api.séance.com/';



// WEBPACK FOOTER //
// ./config.js